import { createStore, applyMiddleware, combineReducers } from "redux";
import storageSession from "redux-persist/lib/storage/session";
import { persistStore, persistReducer } from "redux-persist";
import { authReducer } from "../LoginRedux/Reducer";
import themeReducer from "../reducers/themeReducer";
import { newPasswordReducer } from "../ChangePassword/reducers";
// import logger from "redux-logger";
import thunk from "redux-thunk";
import { markorderReducer } from "../MarkOrderRedux/Reducer";
import { packageTrackerReducer } from "../packageTrackerRedux/Reducer";
import { cancelOrderReducer } from "../CancerOrderRedux/reducers";
import { statCheckerReducer } from "../StatRedux/reducers";
import { pickerorderReducer } from "../PickerOrder/Reducer";
import { pickerstatsReducer } from "../PickerDashboard/reducer";
import { onlineStatusReducer } from "../OnlineStatusRedux/Reducer";
import { newPickerOrderReducer } from "../NewPickerRedux/Reducer";
import { scannerReducer } from "../ScannerRedux/Redux";
import { newCheckerOrderReducer } from "../newCheckerRedux/Reducer";
import { statusReducer } from "../StatusRedux/Reducer";
import { missingMedDashReducer } from "../MissingMedDashboard/reducer";
import { coldChainDashReducer } from "../ColdChainDashboardRedux/reducer";
import { newOrderDetailsReducer } from "../NewOrderDetails/reducer";
import { logisticDashReducer } from "../LogisticDashboardRedux/Reducer";
import { rackReducer } from "../RackRedux/Reducer";
import { dispatchReducer } from "../dispatchRedux/Reducer";
import { LoaderReducer } from "../Loader/Reducer";
import { MedicineLogReducer } from "../MedicineLog/reducer";
import { pickerCheckerReportReducer } from "../PickerCheckerHourly/reducer";
import { pickerTOReducer } from "../PickerTO/Reducer";
import { TOReducer } from "../TOThunks/Reducer";
import { checkerTOReducer } from "../CheckerTO/Reducer";

const authPersistConfig = {
  key: "user",
  storage: storageSession,
  whitelist: ["authReducer", "statusReducer", "MedicineLogReducer"],
};

const rootReducer = combineReducers({
  authReducer,
  themeReducer,
  newPasswordReducer,
  markorderReducer,
  packageTrackerReducer,
  cancelOrderReducer,
  statCheckerReducer,
  pickerorderReducer,
  pickerstatsReducer,
  onlineStatusReducer,
  newPickerOrderReducer,
  scannerReducer,
  newCheckerOrderReducer,
  statusReducer,
  missingMedDashReducer,
  coldChainDashReducer,
  newOrderDetailsReducer,
  logisticDashReducer,
  rackReducer,
  dispatchReducer,
  LoaderReducer,
  MedicineLogReducer,
  pickerCheckerReportReducer,
  pickerTOReducer,
  TOReducer,
  checkerTOReducer,
});
const reduxPersist = persistReducer(authPersistConfig, rootReducer);
const middleWares = [thunk];
// const middleWares = [logger, thunk];

export const reduxStore = createStore(
  reduxPersist,
  applyMiddleware(...middleWares)
);
export const persistor = persistStore(reduxStore);
